/* Consignment payout calculator.
 *
 * Progressive enhancement: the fee tables above already carry every
 * figure, so if this never runs the page is still complete. Config comes
 * from the JSON block the section renders, which is derived from the same
 * settings as the tables — there is no second copy of the rates here.
 *
 * Band selection matches the tables exactly: the break is the first price
 * of the *higher* band, so $499 pays the first rate and $500 pays the
 * second.
 */
(function () {
  'use strict';

  function setup(root) {
    var configEl = root.querySelector('[data-consign-config]');
    var priceEl = root.querySelector('[data-consign-price]');
    var outEl = root.querySelector('[data-consign-out]');

    if (!configEl || !priceEl || !outEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    /* Cents only when there are cents, matching snippets/consign-money.liquid
       so the calculator and the worked examples above it format alike. */
    function money(value) {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: config.currency || 'AUD',
        minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
        maximumFractionDigits: 2
      }).format(value);
    }

    function rateFor(price) {
      var rates = config.fees || [];
      var breaks = config.breaks || [];
      if (price >= breaks[1]) return rates[2];
      if (price >= breaks[0]) return rates[1];
      return rates[0];
    }

    function render() {
      var price = parseFloat(priceEl.value);

      if (!priceEl.value) {
        outEl.textContent = '';
        outEl.removeAttribute('data-state');
        return;
      }

      if (isNaN(price) || price <= 0) {
        outEl.textContent = 'Enter a sale price.';
        outEl.setAttribute('data-state', 'idle');
        return;
      }

      if (price < config.minimum) {
        outEl.textContent =
          'Under our ' + (config.minimumLabel || config.minimum) +
          ' minimum — we would not take this one on its own.';
        outEl.setAttribute('data-state', 'under');
        return;
      }

      var rate = rateFor(price);
      /* Round the fee to cents rather than the payout, so fee + payout
         always reconciles back to the sale price to the cent. */
      var fee = Math.round(price * rate) / 100;
      var payout = price - fee;

      outEl.setAttribute('data-state', 'ok');
      outEl.innerHTML =
        'Fee ' + rate + '% · <span>−' + money(fee) + '</span>' +
        ' &nbsp;→&nbsp; You keep <strong>' + money(payout) + '</strong>';
    }

    priceEl.addEventListener('input', render);
    render();
  }

  function init() {
    document.querySelectorAll('[data-consign-calc]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run when the theme editor swaps the section back in. */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-consign-calc]').forEach(setup);
  });
})();
